module.exports = __webpack_public_path__ + "img/logo_financiera.dbc75a00.png";